<template>
  <div v-loading="loading" class="nx-page nx-report-page kanban-safety-hazard-alarm-board">
    <el-form :inline="true" class="kb-filter-bar" size="small" @submit.native.prevent>
      <el-form-item label="整改状态">
        <el-select v-model="filters.rectifyStatus" clearable placeholder="全部" style="width: 120px" @change="loadData">
          <el-option label="待整改" :value="0" />
          <el-option label="整改中" :value="1" />
          <el-option label="已整改" :value="2" />
          <el-option label="已关闭" :value="3" />
          <el-option label="已取消" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item label="验收结果">
        <el-select v-model="filters.acceptanceResult" clearable placeholder="全部" style="width: 120px" @change="loadData">
          <el-option label="待验收" :value="0" />
          <el-option label="验收通过" :value="1" />
          <el-option label="验收不通过" :value="2" />
          <el-option label="不适用" :value="3" />
        </el-select>
      </el-form-item>
      <el-form-item label="问题类型">
        <el-input
          v-model="filters.problemTypeKeyword"
          clearable
          placeholder="模糊匹配"
          style="width: 140px"
          @input="onFilterKeywordInput"
        />
      </el-form-item>
      <el-form-item label="责任部门">
        <el-input
          v-model="filters.deptKeyword"
          clearable
          placeholder="模糊匹配"
          style="width: 140px"
          @input="onFilterKeywordInput"
        />
      </el-form-item>
      <el-form-item label="仅超期未闭">
        <el-switch v-model="filters.onlyOverdue" @change="loadData" />
      </el-form-item>
      <el-form-item>
        <el-button @click="resetFilters">重置筛选</el-button>
      </el-form-item>
    </el-form>

    <div class="kb-kpi-row">
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">今日上报</div>
        <div class="kb-kpi-value" :class="{ 'is-warn': kpi.today > 0 }">{{ kpi.today }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">待处理</div>
        <div class="kb-kpi-value" :class="{ 'is-danger': kpi.pending > 0 }">{{ kpi.pending }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">超期未闭</div>
        <div class="kb-kpi-value" :class="{ 'is-danger': kpi.overdue > 0 }">{{ kpi.overdue }}</div>
      </div>
      <div class="kb-kpi-card">
        <div class="kb-kpi-label">近 7 日累计</div>
        <div class="kb-kpi-value">{{ kpi.week }}</div>
      </div>
    </div>

    <div class="kb-charts-row kb-charts-row--triple">
      <div class="kb-chart-card">
        <div class="kb-chart-head">
          <span>近 7 日隐患发现趋势</span>
        </div>
        <div ref="trendChart" class="kb-chart-box" />
      </div>
      <div class="kb-chart-card">
        <div class="kb-chart-head">
          <span>整改状态分布</span>
        </div>
        <div ref="statusChart" class="kb-chart-box" />
      </div>
      <div class="kb-chart-card">
        <div class="kb-chart-head">
          <span>问题类型 TOP</span>
        </div>
        <div ref="typeChart" class="kb-chart-box" />
      </div>
    </div>

    <div class="kb-section">
      <div class="kb-section-head">
        <span>隐患清单</span>
        <span style="font-size: 12px; color: #64748b">共 {{ filteredList.length }} 条</span>
      </div>
      <el-table :data="pagedTable" border stripe size="small" max-height="480" style="width: 100%">
        <el-table-column prop="hazardCode" label="隐患编号" width="168" show-overflow-tooltip />
        <el-table-column prop="discoveryDate" label="发现时间" width="142" :formatter="fmtTime" />
        <el-table-column prop="createTime" label="上报时间" width="142" :formatter="fmtTime" />
        <el-table-column prop="problemTypeName" label="问题类型" width="110" show-overflow-tooltip />
        <el-table-column prop="responsibleDeptName" label="责任部门" min-width="120" show-overflow-tooltip />
        <el-table-column prop="rectifyPersonName" label="整改负责人" width="100" show-overflow-tooltip />
        <el-table-column prop="problemDescription" label="问题描述" min-width="200" show-overflow-tooltip />
        <el-table-column prop="requiredCompletionDate" label="要求完成" width="110" :formatter="fmtDate" />
        <el-table-column prop="rectifyStatus" label="整改状态" width="92">
          <template slot-scope="{ row }">
            <el-tag :type="tagRectify(row.rectifyStatus)" size="mini">{{ rectifyText(row.rectifyStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="acceptanceResult" label="验收" width="100">
          <template slot-scope="{ row }">
            <span>{{ acceptanceText(row.acceptanceResult) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createName" label="录入人" width="88" show-overflow-tooltip />
      </el-table>
      <el-pagination
        v-if="filteredList.length > pageSize"
        style="margin-top: 12px; text-align: right"
        :current-page.sync="page"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="filteredList.length"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as echarts from 'echarts'
import NxReportHeader from '@/components/nx/report/NxReportHeader.vue'
import { fetchSafetyHazardAlarmBoard } from './api'
import { RECTIFY_STATUS_LABEL, ACCEPTANCE_LABEL } from '../utils/mockSafetyHazardRectify'

export default {
  name: 'KanbanSafetyHazardAlarmBoard',
  components: { NxReportHeader },
  data() {
    return {
      loading: false,
      rawList: [],
      autoRefresh: true,
      refreshTimer: null,
      filters: {
        rectifyStatus: '',
        acceptanceResult: '',
        problemTypeKeyword: '',
        deptKeyword: '',
        onlyOverdue: false
      },
      kpi: { today: 0, pending: 0, overdue: 0, week: 0 },
      chartInstances: [],
      page: 1,
      pageSize: 12,
      keywordDebounceTimer: null
    }
  },
  computed: {
    /** 列表已由后端按筛选条件过滤 */
    filteredList() {
      return this.rawList
    },
    pagedTable() {
      const start = (this.page - 1) * this.pageSize
      return this.filteredList.slice(start, start + this.pageSize)
    },
    tickerText() {
      const urgent = this.rawList.filter((r) => {
        const req = r.requiredCompletionDate
        const open = r.rectifyStatus === 0 || r.rectifyStatus === 1
        return req && open && req < Date.now()
      })
      const latest = [...this.rawList].sort((a, b) => b.createTime - a.createTime).slice(0, 3)
      const parts = []
      if (urgent.length) {
        parts.push(`超期未闭 ${urgent.length} 条，请优先督办。`)
      }
      if (latest.length) {
        parts.push(
          `最新上报：${latest
            .map((x) => `${x.hazardCode}（${x.problemTypeName}）`)
            .join(' · ')}`
        )
      }
      return parts.join(' ')
    }
  },
  watch: {
    filteredList: {
      handler() {
        this.page = 1
        this.buildKpi()
        this.$nextTick(() => this.renderCharts())
      }
    },
    autoRefresh(val) {
      this.clearRefreshTimer()
      if (val) this.startRefreshTimer()
    }
  },
  mounted() {
    this.loadData()
    this.startRefreshTimer()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy() {
    this.clearRefreshTimer()
    if (this.keywordDebounceTimer) clearTimeout(this.keywordDebounceTimer)
    window.removeEventListener('resize', this.onResize)
    this.disposeCharts()
  },
  methods: {
    rectifyText(s) {
      return RECTIFY_STATUS_LABEL[s] != null ? RECTIFY_STATUS_LABEL[s] : String(s)
    },
    acceptanceText(s) {
      return ACCEPTANCE_LABEL[s] != null ? ACCEPTANCE_LABEL[s] : String(s)
    },
    tagRectify(s) {
      if (s === 0) return 'danger'
      if (s === 1) return 'warning'
      if (s === 2) return 'success'
      if (s === 3) return 'info'
      return ''
    },
    fmtTime(row, col, val) {
      return val != null ? moment(val).format('YYYY-MM-DD HH:mm') : '—'
    },
    fmtDate(row, col, val) {
      return val != null ? moment(val).format('YYYY-MM-DD') : '—'
    },
    buildQuery() {
      const f = this.filters
      const p = {}
      if (f.rectifyStatus !== '' && f.rectifyStatus != null) p.rectifyStatus = f.rectifyStatus
      if (f.acceptanceResult !== '' && f.acceptanceResult != null) p.acceptanceResult = f.acceptanceResult
      const tkw = (f.problemTypeKeyword || '').trim()
      if (tkw) p.problemTypeKeyword = tkw
      const dkw = (f.deptKeyword || '').trim()
      if (dkw) p.deptKeyword = dkw
      if (f.onlyOverdue) p.onlyOverdue = true
      return p
    },
    goClosedLoop() {
      this.$router.push('/kanban-management/safety-hazard-closed-loop-board')
    },
    onFilterKeywordInput() {
      if (this.keywordDebounceTimer) clearTimeout(this.keywordDebounceTimer)
      this.keywordDebounceTimer = setTimeout(() => {
        this.keywordDebounceTimer = null
        this.loadData()
      }, 450)
    },
    resetFilters() {
      if (this.keywordDebounceTimer) {
        clearTimeout(this.keywordDebounceTimer)
        this.keywordDebounceTimer = null
      }
      this.filters = {
        rectifyStatus: '',
        acceptanceResult: '',
        problemTypeKeyword: '',
        deptKeyword: '',
        onlyOverdue: false
      }
      this.loadData()
    },
    clearRefreshTimer() {
      if (this.refreshTimer) {
        clearInterval(this.refreshTimer)
        this.refreshTimer = null
      }
    },
    startRefreshTimer() {
      if (!this.autoRefresh) return
      this.refreshTimer = setInterval(() => this.loadData(), 60000)
    },
    async loadData() {
      this.loading = true
      try {
        const res = await fetchSafetyHazardAlarmBoard(this.buildQuery())
        this.rawList = (res && res.list) || []
        this.buildKpi()
        this.$nextTick(() => this.renderCharts())
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    },
    buildKpi() {
      const list = this.filteredList
      const startOfDay = moment().startOf('day').valueOf()
      const weekAgo = moment().startOf('day').subtract(6, 'day').valueOf()
      const today = list.filter((r) => r.createTime >= startOfDay).length
      const pending = list.filter((r) => r.rectifyStatus === 0 || r.rectifyStatus === 1).length
      const now = Date.now()
      const overdue = list.filter((r) => {
        const req = r.requiredCompletionDate
        const closed = r.rectifyStatus === 2 || r.rectifyStatus === 3 || r.rectifyStatus === 4
        return req && !closed && req < now
      }).length
      const week = list.filter((r) => r.discoveryDate != null && r.discoveryDate >= weekAgo).length
      this.kpi = { today, pending, overdue, week }
    },
    disposeCharts() {
      this.chartInstances.forEach((c) => c && c.dispose())
      this.chartInstances = []
    },
    onResize() {
      this.chartInstances.forEach((c) => c && c.resize())
    },
    renderCharts() {
      this.disposeCharts()
      const list = this.filteredList
      const days = []
      for (let i = 6; i >= 0; i--) {
        days.push(moment().startOf('day').subtract(i, 'day'))
      }
      const keys = days.map((d) => d.format('YYYY-MM-DD'))
      const trendCounts = keys.map((key) =>
        list.filter(
          (r) =>
            r.discoveryDate != null && moment(r.discoveryDate).format('YYYY-MM-DD') === key
        ).length
      )

      const t = echarts.init(this.$refs.trendChart)
      t.setOption({
        tooltip: { trigger: 'axis' },
        grid: { left: '3%', right: '4%', bottom: '3%', top: '12%', containLabel: true },
        xAxis: { type: 'category', data: keys.map((k) => k.slice(5)), axisLabel: { color: '#64748b' } },
        yAxis: { type: 'value', minInterval: 1, axisLabel: { color: '#64748b' } },
        series: [
          {
            type: 'bar',
            data: trendCounts,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#f59e0b' },
                { offset: 1, color: '#ea580c' }
              ])
            }
          }
        ]
      })
      this.chartInstances.push(t)

      const st = { 0: 0, 1: 0, 2: 0, 3: 0, 4: 0 }
      list.forEach((r) => {
        if (st[r.rectifyStatus] !== undefined) st[r.rectifyStatus]++
      })
      const pieData = [
        { name: '待整改', value: st[0] },
        { name: '整改中', value: st[1] },
        { name: '已整改', value: st[2] },
        { name: '已关闭', value: st[3] },
        { name: '已取消', value: st[4] }
      ].filter((x) => x.value > 0)

      const p = echarts.init(this.$refs.statusChart)
      p.setOption({
        tooltip: { trigger: 'item', formatter: '{b}: {c} ({d}%)' },
        legend: { bottom: 0, textStyle: { color: '#64748b', fontSize: 10 } },
        series: [
          {
            type: 'pie',
            radius: ['40%', '65%'],
            center: ['50%', '44%'],
            data: pieData.length ? pieData : [{ name: '无数据', value: 1, itemStyle: { color: '#e2e8f0' } }],
            label: { formatter: '{b}\n{d}%', fontSize: 10 }
          }
        ]
      })
      this.chartInstances.push(p)

      const typeMap = {}
      list.forEach((r) => {
        const n = r.problemTypeName || '未知'
        typeMap[n] = (typeMap[n] || 0) + 1
      })
      const typeEntries = Object.entries(typeMap)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 8)

      const b = echarts.init(this.$refs.typeChart)
      b.setOption({
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
        grid: { left: '3%', right: '8%', bottom: '3%', top: '8%', containLabel: true },
        xAxis: { type: 'value', minInterval: 1, axisLabel: { color: '#64748b' } },
        yAxis: {
          type: 'category',
          data: typeEntries.map((x) => x[0]),
          axisLabel: { color: '#64748b', fontSize: 10 },
          inverse: true
        },
        series: [
          {
            type: 'bar',
            data: typeEntries.map((x) => x[1]),
            itemStyle: { color: '#0ea5e9', borderRadius: [0, 4, 4, 0] }
          }
        ]
      })
      this.chartInstances.push(b)
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';

.kb-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.kb-ticker {
  margin-bottom: 16px;
  border-radius: 12px;
}
</style>
